import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(duration);
dayjs.extend(relativeTime);

interface DateCountdownProps {
  endTime: string; // ISO
  name: string;
}

const DateCountdown: React.FC<DateCountdownProps> = ({ endTime, name }) => {
  const [diff, setDiff] = useState(getDiff(endTime));
  const duration = dayjs.duration(diff);

  useEffect(() => {
    const interval = setInterval(() => {
      setDiff(getDiff(endTime));
    }, 1000);

    return () => clearInterval(interval);
  }, [endTime]);

  const isLessThan24Hours = duration.asHours() < 24;
  const timeIsUp = diff <= 0;

  return (
    <p data-testid={'DateCountdown'} className={'text-sm'}>
      <span className={'font-bold text-lg'}>
        {timeIsUp ? 'Starting in a few moments...' : `Live Sale with ${name}`}
      </span>

      <br />

      {!timeIsUp && <span>{buildCountdown(duration, isLessThan24Hours)} </span>}

      <span>{timeIsUp ? `Live Sale with ${name}` : buildDate(endTime)}</span>
    </p>
  );
};

export { DateCountdown };

// PRIVATE

const getDiff = (endTime: string) => {
  const nowDay = dayjs(Date.now());
  const endDay = dayjs(endTime);
  return endDay.diff(nowDay);
};

const buildCountdown = (
  duration: duration.Duration,
  isLessThan24Hours: boolean,
): string => {
  return isLessThan24Hours
    ? `starting in ${new Date(duration.asMilliseconds())
        .toISOString()
        .substr(11, 8)},`
    : `in ${duration.humanize()},`;
};

const buildDate = (endTime: string) => {
  return (
    <span data-testid={'date'}>
      on {dayjs(endTime).format('dddd, MMMM D, h:mm A')}
    </span>
  );
};
